var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewChatHr(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.08591H3C1.89543 1.08591 1 1.98134 1 3.08591V15.0859C1 16.1905 1.89543 17.0859 3 17.0859H15C16.1046 17.0859 17 16.1905 17 15.0859V9.08591M15.4142 5.50011L16.5 4.41435C17.281 3.6333 17.281 2.36698 16.5 1.58594C15.7189 0.804885 14.4526 0.80489 13.6715 1.58595L12.5858 2.67168M15.4142 5.50011L9.37795 11.5365C9.09875 11.8157 8.74315 12.006 8.35596 12.0834L5.41422 12.6718L6.00257 9.73002C6.08001 9.34285 6.27032 8.98725 6.54951 8.70805L12.5858 2.67168M15.4142 5.50011L12.5858 2.67168",
    stroke: "#838383",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewChatHr);
export default __webpack_public_path__ + "static/media/newChatHR.0625caa3d2d50c49435f34a77a1498d4.svg";
export { ForwardRef as ReactComponent };